import { render, staticRenderFns } from "./Creation_3_Motives.vue?vue&type=template&id=b177a124&scoped=true&"
import script from "./Creation_3_Motives.vue?vue&type=script&lang=js&"
export * from "./Creation_3_Motives.vue?vue&type=script&lang=js&"
import style0 from "./Creation_3_Motives.vue?vue&type=style&index=0&id=b177a124&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b177a124",
  null
  
)

export default component.exports